import { stripExtraTags } from "@common/domain/tag-filter";
import { ChatSession } from "../interfaces/Chat";

export function buildChatSession(title?: string, personaId?: string, explicitChatId?: string): ChatSession {
  const newChatSessionId = explicitChatId ?? crypto.randomUUID();
  const currentDate = new Date();
  const currentMonthYear = currentDate.toLocaleString("default", {
    month: "long",
    year: "numeric",
  });
  return {
    chatInfo: {
      chatId: newChatSessionId,
      chatTitle: title ? stripExtraTags(title) : "Untitled",
      timestamp: currentDate.toISOString(),
      conversation: [],
      personaId,
    },
    month: currentMonthYear,
  };
}

/** Insert `session` at the front of `sessions` unless a session with the same chatId already exists. */
export function upsertChatSession(sessions: ChatSession[], session: ChatSession): ChatSession[] {
  if (sessions.some((s) => s.chatInfo.chatId === session.chatInfo.chatId)) return sessions;
  return [session, ...sessions];
}
